import { render, staticRenderFns } from "./TabsComponent.vue?vue&type=template&id=905e87c0&scoped=true&"
import script from "./TabsComponent.vue?vue&type=script&lang=js&"
export * from "./TabsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905e87c0",
  null
  
)

export default component.exports